var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyLockTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 71.7 61.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#9e9e9d;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69{stroke-width:0px;}.cls-2{fill:#7c7c7c;}.cls-3{fill:#3b3c3c;}.cls-4{fill:#b4b4b3;}.cls-5{fill:#b6b6b6;}.cls-6{fill:#6c6c6c;}.cls-7{fill:#222;}.cls-8{fill:#868787;}.cls-9{fill:#b8b7b7;}.cls-10{fill:#454545;}.cls-11{fill:#363636;}.cls-12{fill:#252525;}.cls-13{fill:#a8a8a9;}.cls-14{fill:#5d5d5c;}.cls-15{fill:#bababa;}.cls-16{fill:#b1b0b0;}.cls-17{fill:url(#Gradient_bez_nazwy_3-2);}.cls-18{fill:#8e8e8e;}.cls-19{fill:#8c8c8c;}.cls-20{fill:#b5b5b4;}.cls-21{fill:#585858;}.cls-22{fill:url(#Gradient_bez_nazwy_3-3);}.cls-23{fill:#3e3e3f;}.cls-24{fill:none;}.cls-25{fill:#141414;}.cls-26{fill:#5c5b5b;}.cls-27{fill:url(#Gradient_bez_nazwy_3);}.cls-28{fill:#bbbaba;}.cls-29{fill:#666665;}.cls-30{fill:#232323;}.cls-31{fill:#b9b9b9;}.cls-32{fill:#2b2b2b;}.cls-33{fill:#b7b7b6;}.cls-34{fill:#737373;}.cls-35{fill:#7f7f7f;}.cls-36{fill:#a5a4a4;}.cls-37{fill:#8d8d8d;}.cls-38{fill:#bcbbbb;}.cls-39{fill:#b6b5b5;}.cls-40{fill:#706f6f;}.cls-41{fill:#4c4c4c;}.cls-42{fill:#b2b2b1;}.cls-43{fill:#868687;}.cls-44{fill:#4e4e4e;}.cls-70{clip-path:url(#clippath);}.cls-45{fill:#b0b0af;}.cls-46{fill:#6b6b6a;}.cls-47{fill:#a6a6a6;}.cls-48{fill:#565656;}.cls-49{fill:#9a9a9a;}.cls-50{fill:#616161;}.cls-51{fill:#404040;}.cls-52{fill:#3c3c3c;}.cls-53{fill:#272828;}.cls-54{fill:#282828;}.cls-55{fill:#272728;}.cls-56{fill:#3e3e3e;}.cls-57{fill:#8f8f8f;}.cls-58{fill:#a6a5a5;}.cls-59{fill:#4e4e4d;}.cls-60{fill:#767576;}.cls-61{fill:#2e2e2f;}.cls-62{fill:#808181;}.cls-63{fill:#292929;}.cls-64{fill:#767676;}.cls-65{fill:#555;}.cls-66{fill:#babab9;}.cls-67{fill:#818282;}.cls-68{fill:#303030;}.cls-69{fill:#b2b1b1;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m71.7,61.2h-9.1c0-8.6,0-17.1,0-25.7-.1-15.4-12.9-27.6-27.5-27.2-13.7.4-25.3,11.6-26,26,0,9,0,17.9,0,26.9H0v-25.6c2-47.4,69.2-47.4,71.1,0l.6,25.6Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_3",
    x1: 0,
    y1: 26.7,
    x2: 8.5,
    y2: 26.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5b5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8f8f8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_3-2",
    x1: 0.6,
    y1: 29,
    x2: 8.5,
    y2: 29,
    xlinkHref: "#Gradient_bez_nazwy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_3-3",
    x1: 35.9,
    y1: -1.6,
    x2: 35.9,
    y2: 69.3,
    xlinkHref: "#Gradient_bez_nazwy_3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m29.4,5.8c0-.3-.6-.4-.3-.8.2-.3.4,0,.6,0,1.5,0,2.9-.2,4.4-.2,1.7,0,3.4.2,5.1,0,1.5-.2,3,.2,4.4.7,1.3.4,2.7.8,4,1.5,2.4,1.3,4.8,2.5,6.8,4.4.1.1.4.2.5.1,1.4-.7,3-.4,4.5-.5.7,0,1.3.1,1.4,1,0,.4.2,1.1.9.5,1.2-1,2-.3,2.8.5.4.4.7,2,1.7.6.2.4.4.8.8.1.9,0,.8,1,1.3,1.4.5.7.7,1.5,1,2.2.1.3.2.6.4.9.4.8.6,1.6.7,2.4,0,.6-.4,1.3-.9.6-1.3-1.8-3.2-1.4-4.9-1.4-1.4,0-2.9.5-4.1-.7-.2,0-.3-.2-.3-.4,0-.1.2-.5-.3-.4-.1,0-.2,0-.3-.2-1-.8-1.1-2.2-2.3-2.8-1.8-1.4-3.1-3.3-5-4.5-.7-.5-1.4-1-2.1-1.4-1-.6-1.9-1.3-3-1.5-2.6-.9-5.2-2-8-2.1-.2,0-.4,0-.7-.1-1.9-.2-3.8-.2-5.7,0-1.1-.1-2.3.7-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m55.9,2.5c2.4,1.3,4.3,3.3,6.4,5.1.2.3.7.4.9.7.3.3.6.6.8.8.3.4.9.7.7,1.3,0,0,0,0-.1.1-1,0-1.2-1-1.7-1.5-1.9-1.9-3.8-3.8-6-5.4-.4-.3-.9-.6-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m65.7,11.4c.2.7.9,1.1,1.1,1.8-1.7,0-1.8-1.5-2.1-2.6,0,0,0,0,0,0,.6,0,.9.3,1,.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m1.9,20.6c0,.2.1.5.3.6.2.1.2-.2.3-.3.6-1,1.5-1.6,2.6-1.9,1.3-.3,2.1-1.3,3.2-1.9,2.4-1.2,2.6-1.2,3.2,1.4,0,0,0,.1.1.2.3.4,0,.8-.1,1.1-1.1,2.3-1.7,4.8-2,7.3-.1.4-.2.9-.5,1.1-1-.6-.5-1.5-.5-2.3,0-.9.3-1.8,0-2.7-2.1,1.4-4.2.9-6.4.5-.6-.1-.9-.5-.8-1.2,0-.4,0-.9,0-1.3,0-.3.1-.6.4-.7,0,0,.1,0,.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m14.3,3.4c0,.6-.3,1-.8,1.4-.8.6-1.6,1.3-1.8,2.3,0,.2-.2.5-.4.5-1.5.6-2.1,2.1-3.4,3-1.1.7-1.9,1.8-2.8,2.7,0,0,0,0-.1-.1-.1-1.1.9-1.6,1.2-2.4.9-1.2,1.9-2.4,3-3.5.5-.4.9-.9,1.3-1.4,1.2-1,2.2-2.1,3.9-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m5.1,13.2c.2.8-.5,1.2-.8,1.7-1,1.8-1.4,3.9-2.4,5.7,0,0,0,0,0,0-.7-.8-.1-2,.3-2.9.3-.6.5-1.3.8-1.9.5-.8.8-1.7,1.4-2.4.2-.2.4-.3.7-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m60.4,19c.4-.1,1-1,1.2,0,.2.9.4.8,1.2.6,1.7-.3,3.5-.3,5.2,0,.8.1,1.4.6,1.7,1.4,0,.2.2.5.4.2.1,0,0-.3.1-.5.9,0,.5.9.8,1.3.3,1.5.7,2.9.6,4.5,0,.6.1,1.3-.3,1.8-.9,0-.6-.7-.7-1.1-.4-1.9,0-3.9-2.6-4-1.4,0-2.9,0-4.3-.1-.7-.1-1.1.5-1.7.6-.3-.2-.3-.4-.4-.7,0-.8-.3-1.6-.9-2.3-.3-.4-.8-.9-.4-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m59.9,19.3c-.1-.3-.2-.7-.3-1,.1-.1.2-.1.4,0h0c.1.2.4,0,.5.3,0,.2,0,.4,0,.5.4,1.3,1.7,2.2,1.6,3.7-.6.2-.8-.4-1.1-.7-.4-.9-1.2-1.7-1.1-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m59.9,18.3c-.1,0-.2,0-.4,0-.7-1.1-1.4-2.1-2.2-3.2,1.6.5,1.7,2.1,2.5,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m60.4,18.5c-.2,0-.4,0-.5-.3.3,0,.2-.8.6-.6.4.2,0,.6,0,.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1.6,21.2c0,2.3-.1,2.7,2.4,2.6.8,0,1.7,0,2.5,0,.4,0,.9,0,1.1-.5.2-.5.5-.9.9-.6.4.2.4.7.4,1.2,0,1.1-.2,2.2-.2,3.2,0,.4-.1.9.2,1.3.3.3.1.7.1,1.1-.2,1.3,0,2.7,0,4-.1,1.8.2,3.6-.2,5.4-.9,0-.6-.7-.7-1.2,0-.6,0-1.3,0-1.9,0-2.1,0-4.3,0-6.4,0-2-.4-2.3-2.4-1.7-.8.2-1.6.4-2.4.4-2.6-.2-1.4,2-2.6,1.7-.9-.9-.5-2.1-.5-3.1,0-1.6.4-3.1.8-4.6,0-.3.1-.7.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m8.5,29.1c0,1.4,0,2.8,0,4.2-.1,0-.2,0-.3,0-.6-1.5-1.5-1.8-3.7-1.3-.5.1-1,.6-1.5.4-1-.3-1.5.1-1.7,1-.4.6-.8.5-1-.1-.3-.6-.2-1.3-.3-1.9,0-1.9,0-3.8,0-5.6,0-1.2.3-2.3.5-3.4,0-.1,0-.3,0-.4.2-.5.3-1,.4-1.5.2-.4.3-.9.8-1,0,.4,0,.8,0,1.1-.2.1-.3.3-.3.5-.8,2.8-1.5,5.6-.8,8.5.3.2.2.6.2.7,2.1,0,3.8-1.1,5.7-1.3,1.1-.2.7.8.9,1.3.5-.3,0-1.2.8-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m8.8,8c-.3-.4-.5,0-.8,0-.2,0-.3-.1-.3-.3.5-.4,1-.6,1.6-.2,0,.3-.3.4-.5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m61.2,22c.3.3.6.5.8.8,0,.3,0,.5,0,.8.7-.1,1.3,0,1.8.4.8.7,1.7.9,2.7.8,1.3-.1,2.4.4,3.5.8.7.3.5,1.1,1,1.4,0,.4-.2.9.3,1.3.2.2.2.5,0,.8-.1,0-.2.2-.4.2-1.3,0-2.5-.4-3.7-.8-.9-.3-1.7-.4-2.6,0-.6.2-1.1.4-1.3,1.1,0,.3-.3.6-.7.3-.5-1.2,0-2.5-.7-3.7-.5-1.1-.6-2.3-1-3.4,0-.3,0-.6.2-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m71,27c-.2,0-.4.4-.5.2-.3-1.9-1.9-1.8-3.3-2-1.1-.2-2.4.2-3.3-.6-.6-.5-1.2-.8-2-1,.6-.9,1.2-1.1,2.3-.9,1.3.3,2.6,0,3.9,0,1.5,0,2.5,1,2.5,2.4,0,.6.1,1.2.3,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m71.3,26.4c.4.7.1,1.4.3,2.1.3.3.3.7.3,1.1,0,2.3,0,4.6,0,6.9,0,.2-.1.3-.2.4-1.2-.2-.5-1.2-.7-1.8,0-.4-.1-.9,0-1.3,0-.2,0-.4,0-.7.2-1.4-.4-2.8.4-4.1,0-.3,0-.5,0-.8,0-.6,0-1.3,0-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m8.5,29.1c-.3.2-.2.5-.3.8,0,.4.2.8-.2,1.1-.2.2-.4,0-.4-.1-.2-.5-1-.8-.3-1.4,0,0,0-.1,0-.3-1.1.4-2.3.2-3.3,1.1-.4.3-.9.2-1.4,0-.4-.1-.7-.1-.9.3-.2.3-.4.8-.9.5-.4-.2,0-.6,0-.9,0-.2,0-.3,0-.5.4-.3.2-.7.3-1.1,0-.6.5-1,1-1,1.4,0,2.8-.3,4.1-.5,2.2-.4,2.2-.2,2.2,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m8.2,33.4c0,0,.2,0,.3,0,0,.8,0,1.6,0,2.4-.7,0-.3-.6-.4-1,.2,1.3-.6,1.4-1.3.9-1.5-.8-2.9,0-4.4,0-.7,0-1.5-.2-2,.6-.3,0-.5-.3-.6-.6-.3-1.5,0-3-.1-4.5,0-1.5.1-3.1-.1-4.6,0-.4,0-.7.3-1,.1-.1.3-.1.4-.1,0,2.4,0,4.8.1,7.2,0,.3,0,.7.4.9.1-.2.2-.4.3-.5,1.9,0,3.8-1,5.7.4.5.4,1,0,1.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m.5,36.3c.2-.4,0-.9.8-.8,1.4,0,2.7-.1,4-.6.6-.2.8.4,1.3.5.7.2,1.5.6,1.4-.8.4.4,0,.9.5,1.2,0,.6,0,1.2,0,1.9-.5.1,0,.9-.7,1.1-.4-.6-.8-1.4-1.9-1.3-.8.1-1.7,0-2.4.5-.2.2-.6.3-.9.2-.9-.2-1.6.2-2.3.5-.6-.9-.7-1.7.2-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m.5,38.6c.2-.8.5-1.4,1.6-.8.3.1.9.1,1,0,.9-1.1,2.1-.6,3.2-.7,1-.1,1.6.2,1.4,1.3.6,0-.3-1.3.8-.7,0,.4-.2.9.2,1.3.3,1.1,0,2.2.2,3.4,0,.9,0,1.9,0,2.8,0,.2-.2.3-.3.2-.2-.1-.3-.3-.4-.6-.1-.6,0-1.2,0-1.8,0-.4,0-.7,0-1.1,0-.3,0-.7,0-1,0-.8-.5-1.2-1.2-1.2-1,0-1.9-.1-2.9,0-1.3.3-2.4,0-3.5-.6,0-.1,0-.3,0-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m8.8,42.4c0-1.2,0-2.3,0-3.5,0-1.8,0-3.7,0-5.5,0,0,.1,0,.2,0,0,3,0,6,0,9,0,.1-.1.1-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m9,33.4c0,0-.1,0-.2,0,0-1.3-.3-2.7.2-4,0,1.3,0,2.6,0,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m8.2,33.4c-.6,1-1.4.6-2.1.2-.5-.3-1.1-.5-1.7-.7-.2,0-.7-.1-.7,0-.8,1.4-1.8.3-2.7.2,0-1,.6-1.4,1.5-1,.5.2.8,0,1.2-.2.9-.5,2-.5,2.9-.4,1,.1,1.6.7,1.5,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m.8,22.2c-.2,0-.4,0-.5,0-.1-1,0-1.1.6-1.3,0,.4,0,.8,0,1.1,0,0,0,0,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m9,55.6c0,.5,0,1.1,0,1.6,0,1.1-.6,1.5-1.6,1.5-2.1,0-4.3,0-6.4-.1-.2,0-.5,0-.7-.2-.3-.3-.3-.7-.2-1.1,0-.1.1-.3.2-.4,1.5-.4,2.9-.3,4.4-.2,1.3.1,2.6.2,3.7-.7,0-.1.1-.2.2-.4.1-.1.2-.1.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m.8,58.3c2.2,0,4.4,0,6.6,0,.9,0,1.4-.3,1.6-1.1,0,.2,0,.3,0,.5.2.2,0,.5,0,.8,0,.3-.2.5-.4.7-2,.5-4,.4-5.9.2-.5-.3-1-.2-1.5-.3-.4-.1-.8-.2-.5-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m9,55.6c0,0-.1,0-.2,0-2.5-.5-5.1-.2-7.6-.4-.3,0-.6,0-.9-.1-.3-.4-.3-.8-.1-1.2.3-.5.9-.3,1.3-.3,1.5.3,3.1.2,4.7.5.9.1,1.7.2,2.5-.3.1,0,.2,0,.4,0,0,.6,0,1.2,0,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m9,53.7c0,0-.1,0-.2,0,0,0,0,0-.2-.1-.2-.5-.2-1-.2-1.5,0-.7,0-1.5,0-2.2,0-.6,0-1.2,0-1.9.1-.9-.3-2,.4-2.8,0-1,0-1.9,0-2.9,0,0,.1,0,.2,0,0,3.8,0,7.6,0,11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9,58.5c0-.3,0-.5,0-.8,0,0,.2,0,.2,0,0,.3,0,.5,0,.8.2.3.1.5-.3.6-.2-.2-.2-.4,0-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.8,29.9c.5-.3.4-1.7.8-1.7,1.1.2,1.9-.8,3-.3,1.4.6,2.9.8,4.4,1.2.3.6,0,1.2.1,1.7-1.5.5-3,.4-4.4-.2-1.8-.8-1.6.9-2.7.6-.6-.2-.2-.8-.3-1.2.1.9-.2,1.6-.3,2.4,0,.4,0,.8-.5,1-.7-1.1-.5-2.3-.1-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m71,31c0-.6,0-1.2,0-1.9,0,0,.2,0,.3,0,0,1.5,0,3,0,4.5-.8-.2-.6-.8-.6-1.3,0-.5,0-1,.4-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m71,32.3c0,.4-.2,1,.3,1.3,0,0-.2.2-.3.3-2.1.5-4.3.3-6.5.3-.6,0-1-.3-1.1-.9,0-.4,0-.8.5-.9,1-.2,1.9-.7,2.9-.6,1,.1,1.9.2,2.9.1.5,0,1,0,1.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m63.6,33.4c.3.1.4.6.7.5,1.8-.5,3.6.6,5.4-.2.6-.3.9.4,1.3.3,0,.4.2.7.3,1.1-.2.2,0,.6-.4.7-1.3,0-2.6.2-3.8-.4-.5-.2-1,0-1.6,0-.7,0-1.4.2-2-.3-.2-.5-.3-1.1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.5,37c0,1.9,0,3.9,0,5.8-.2,0-.3,0-.4,0-.3-.5-.2-1-.2-1.5,0-.8,0-1.6,0-2.4,0-.4-.2-.9-.2-1.3,0-.7-.1-1.4.4-2,0-.2,0-.4.3-.5.1.7-.2,1.4.2,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m0,40.8c0-1.6,0-3.2,0-4.8.2,0,.3.2.5.3-.3.8-.5,1.6,0,2.4,0,0,0,.2,0,.3.4.7,0,1.4.1,2.1,0,.4,0,.9-.1,1.3,0,.1-.1.3-.3.4-.2,0-.3,0-.4-.1-.3-.6-.3-1.2.1-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m8.5,44.7c0,.2,0,.3,0,.5.2.3.1.5,0,.8-.2.9-.8,1.1-1.7,1-2.2-.2-4.4-.2-6.6.4-.2-.2-.3-.4-.3-.6,0-.6,0-1.2.1-1.8.1-.2.3-.5.5-.5,2.4,0,4.9-.4,7.3,0,.2,0,.4.2.6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m.3,42.6c0,0,0-.2,0-.3.2-.7.7-1.1,1.3-1,1.6.1,3.1-.3,4.6-.2.8,0,1.6,0,2.2.7,0,.4,0,.7,0,1.1-.2,1-.8,1-1.8,1-2-.1-4-.5-5.9.3-.2,0-.4.1-.6,0-.3-.5-.3-1,.1-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m.3,44.2c.6-.7,1.5-.8,2.2-.8,1.4-.1,2.8,0,4.2,0,.7,0,1.3.1,1.8-.6,0,.6,0,1.2,0,1.9-2.2.1-4.3-.3-6.5.3-.6.2-1.2-.6-1.7,0-.2-.3-.2-.5,0-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m.3,41c0-.7,0-1.4.3-2.1,2,.9,4.1.2,6.2.2,1.1,0,1.8.4,1.8,1.6-2.5,0-5.1,0-7.6.4-.2,0-.4,0-.6-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m.3,41c1.7-.7,3.5-.4,5.3-.5,1,0,2-.5,2.9.3,0,.4,0,.7,0,1.1-2.2-.7-4.5.1-6.7-.2-.5,0-1.1.3-1.5.7,0-.4,0-.9,0-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m8.5,46.1c0-.3,0-.5,0-.8,0,0,.2,0,.3,0,0,1,0,1.9,0,2.9-1.1-.6-.5-1.4-.3-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m8.8,55.9c0,.5.1.9-.6,1.1-2.6.4-5.2-.1-7.8,0-.4-.4-.4-.9,0-1.4,1-.5,2-.3,3.1-.2,1.3,0,2.6.3,3.9.2.5,0,1.1,0,1.5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m8.8,55.9c-2.8.2-5.6-.4-8.5-.3,0,0-.1-.2-.2-.3,0-.1,0-.2.1-.3.9-.3,1.9-.1,2.8-.1,1.5,0,3,.2,4.4,0,.7,0,.9.2,1.2.6,0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m.8,58.3c.4,1,1.6.1,2.1.8-.6,1-1.5.4-2.3.6-.1,0-.2,0-.4,0-.2-.2-.3-.4-.3-.7,0-.3,0-.5.3-.7.2,0,.3,0,.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m.3,58.3c0,.3,0,.5,0,.8-.2,0-.3,0-.4,0-.3-.6-.3-1.2.1-1.8,0,0,.2,0,.3,0,0,.4,0,.7,0,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9,59.1c0,.3,0,.5,0,.8.4.8.2,1.4-.7,1.4-2.6,0-5.3.3-7.9-.1-.6-.6-.5-1.1.1-1.5h0c2.2,0,4.4-.2,6.7,0,.6,0,1.1,0,1.5-.6,0-.2.2-.4.2-.5,0,.2,0,.4,0,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m8.8,59c0,.9-.7,1.1-1.2,1-2-.3-4-.2-6-.2-.3,0-.7-.2-1-.3.1-.7.6-.2.9-.2.5,0,1,0,1.5-.3,1.9.2,3.9,0,5.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m8.8,53.8c0,.6-.2.7-.8.7-2.6,0-5.2-.1-7.7-.7,0-.1,0-.3,0-.4.4-.5.9-.6,1.5-.6,2,0,4,.2,6,.2.6,0,.6.5.9.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m.3,53.5c0,0,0,.2,0,.3,0,.4,0,.9,0,1.3,0,0,0,.2,0,.3-.5-.6-.2-1.2-.2-1.9,0,0,0,0,.1,0,0,0,0,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m8.5,46.1c.1.7-.3,1.5.3,2.1,0,.6,0,1.2,0,1.8-.8-1.2-2-1-3.2-.9-1.8,0-3.6,0-5.4,0,0-.6-.2-1.2.1-1.8.3-.6.7-.8,1.4-.8,1.6.1,3.2,0,4.8,0,.7,0,1.4.2,1.9-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m.3,49.2c.3-.5.8-.5,1.4-.5,2-.1,4,.3,6-.2.4-.1.6.3.7.6.1.3,0,.7.3,1,0,.6,0,1.2,0,1.9-.3,0-.4-.1-.5-.3-.1-1-.8-1.1-1.6-1.1-2,0-4,0-6,0-.1,0-.3-.1-.4-.2,0-.4-.2-.7,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m8.8,53.7c-.6-.9-1.5-.3-2.2-.3-2.1-.3-4.2-.6-6.3,0,0,0,0,0,0,0-.2-.4-.1-.9,0-1.3.3-.6.9-.4,1.4-.5,1.8-.3,3.6-.1,5.4-.2.7,0,1.3.2,1.8.6,0,.5,0,1.1,0,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m8.8,52.2c-2.8-.4-5.6-.3-8.5,0-.2-.3-.2-.6,0-.9.7-.4,1.4-.3,2.2-.3,1.6,0,3.1,0,4.7,0,.6,0,1.1,0,1.3.7,0,0,.2.2.3.3,0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m63.6,33.4c0,.5,0,1.1,0,1.6-.1,0-.3,0-.4,0-.1-.8.1-1.7-.2-2.6,0-1.1.9-2,.5-3.2.4,0,.3.3.3.4,0,.5-.3,1.2.2,1.5.6.3.6-.6,1-.8.4-.3.9-.5,1.2-.2,1.4,1.3,3.2.3,4.8,1,0,.4,0,.9,0,1.3-2.3.1-4.5-.4-6.8.2-.5.1-.6.4-.6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m63.1,32.3c.5.8.1,1.8.3,2.6,0,0-.2,0-.3,0,0-.9,0-1.8,0-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m63.1,34.9c.2,0,.4,0,.5,0,2.5-.4,4.9.3,7.4.5,0,.7,0,1.4,0,2.1-1.3.6-2.7.4-4.1.3-.4,0-.6-.2-1,0-1,.8-1.9.6-2.9,0,0-1,0-1.9,0-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m63.1,37.9c1.3.4,2.4.1,3.4-.7.2-.1.3-.3.6-.1.2.1,0,.3,0,.5-.2.4.1.3.3.2,1.2-.3,2.4,0,3.7-.1,0,.4.2.7.3,1.1,0,1.1-.6,1.5-1.7,1.4-1.2,0-2.4,0-3.6,0-.9,0-1.8,0-2.6.6,0,.1-.2.2-.3.2-.7-.1-.2-.8-.5-1.1,0-1.4,0-2.8,0-4.2.5,1.1,0,2.3.3,3.4.4-.3.1-.7.2-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m71.6,48.2c0,0,.1,0,.2,0,.5.4.4.9.4,1.4,0,1.2,0,2.3,0,3.5,0,1.1,0,2.3,0,3.4-.3.6,0,1.4-.5,2-2.2-.3-4.4-.2-6.7,0-.7,0-1.5.3-2.2-.2-.2-.5-.1-1.1,0-1.6.3-.9,1.1-.9,1.8-.9,2.1,0,4.3,0,6.4,0,.1-.2.4.5.4,0,0-.6,0-1.2-.1-1.8,0-1,0-2,0-3,.1-.9-.3-1.8.4-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m71.6,48.2v2.6c-.2,0-.3,0-.4,0-.2-.2-.2-.5-.2-.8,0-1.1,0-2.3,0-3.4,0-.1,0-.3.2-.4,0-.1.2-.2.4-.1,0,.7,0,1.5,0,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m71.5,46c0,0-.2,0-.2,0,0,0,0,0-.2-.1-.2-.5-.2-1-.2-1.4,0-.4,0-.8.1-1.3,0-.1.1-.2.2-.3,0,0,.2,0,.2,0,0,1.1,0,2.1,0,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m71.3,42.9c0,0,0,.2,0,.3-.5.4-1.1.3-1.6.3-1.8,0-3.6-.4-5.4,0-.6.2-1.1-.1-1.4-.7,0-.7-.3-1.4.2-2h0c.7-.5,1.4.1,2.2.1,1.4,0,2.9,0,4.3,0,.6,0,1.2,0,1.7.4v1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m71.3,41.3c-1.5,0-3,0-4.6,0-1.2,0-2.5.2-3.6-.5.4-1.6,1.9-1.1,2.8-1.1,1.2,0,2.5,0,3.7,0,.9.1,1.5-.2,1.7-1.1,0,.9,0,1.8,0,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m71.3,55.9c-2.3.5-4.6.2-7,.3-.6,0-1.1,0-1.5.5,0,.1-.2.1-.2,0,0-.5,0-1.1,0-1.6.4-.3,0-1.1.7-1.1,2.2.7,4.6.4,6.8.5,1.3,0,1.3,0,1.1,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m62.8,58.3c2.6-.1,5.1-.2,7.7-.5.8,0,.7.5,1,.7.4.7.1.7-.6.8-2.8.4-5.6.2-8.4.5,0-.3,0-.5,0-.8.2-.2,0-.6.2-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m62.6,59.8c.6-.5,1.4-.6,2.1-.5,2.2.2,4.5-.3,6.7-.3.2,0,.1-.4.2-.5,0-.6-.2-1.3.2-1.8.7.8.4,1.8.3,2.7-.3.8-1,.7-1.7.7-1.9,0-3.8.2-5.7.1-.6,0-1.3,0-1.7.6,0,.1-.2.2-.3.2,0,0-.1,0-.2,0,0-.4,0-.7,0-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m63.1,40.8c0,.7,0,1.4,0,2.1.5.6.4,1.3.4,2,0,.4,0,.8-.2,1.1-1,.1-.3-.7-.6-1,0-1.8,0-3.5,0-5.3.4.3,0,.8.5,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m62.6,51.4c0-1.4,0-2.8,0-4.2.9.3.4,1.3.7,1.8,0,.4.1.8.1,1.3,0,.4,0,.8-.2,1.2-.3.3-.5.2-.6-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m62.6,51.4c.2,0,.3.2.5.3,0,0,0,0,.1.1.3.5.2,1.1.1,1.6,0,.1,0,.2-.1.3-.5.2,0,1-.6,1.1,0-1.1,0-2.3,0-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m63.1,49c-.6-.5,0-1.3-.5-1.8,0-.7,0-1.4,0-2.1.4.3,0,.8.5,1,.1,0,.2.2.2.3.1.4.1.8.1,1.2,0,.4,0,.8-.2,1.2,0,0-.1,0-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m62.8,58.3c0,.3,0,.6-.2.8,0-.8,0-1.6,0-2.4,0,0,.2,0,.2,0,0,.5,0,1.1,0,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m62.6,54.8c.4-.3,0-1,.5-1.3.1.2.2.4,0,.5,0,.4.2.9-.5,1,0,0,0-.2,0-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m0,46.6c0-1.3,0-2.7,0-4,0,0,.2,0,.2,0,0,.8,0,1.6,0,2.4,0,.6,0,1.2,0,1.8,0,.1-.2.1-.2,0,0,0,0-.2,0-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m0,46.9c0,0,.2,0,.2,0,0,.2,0,.4,0,.5,0,.6,0,1.2,0,1.9,0,.4,0,.7,0,1.1,0,0-.2,0-.2,0,0-1.1,0-2.3,0-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m-.2,60.7c0-1.7,0-3.4,0-5.1.3.5.1,1.1.2,1.6,0,.6,0,1.2,0,1.8.1.6.4,1.2-.2,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m0,50.3c0,0,.1,0,.2,0,0,0,0,0,0,0,.3.4.3.7,0,1.1,0,.7,0,1.4,0,2.1,0,0-.1,0-.2,0,0-1.1,0-2.1,0-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m-.2,60.7c.4-.5.1-1.1.2-1.6,0,0,.2,0,.3,0,0,.2,0,.4.3.5-.2.4-.3.9-.3,1.3,0,0-.2.2-.3.3h-.1c0,0-.1,0-.1,0,0-.2,0-.3,0-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m.3,51.4c0-.4,0-.7,0-1.1,2.3-.5,4.6-.2,6.9-.3,1.1,0,1.3.7,1.3,1.6-.3-.1-.3-.5-.7-.4-2.5.4-5,0-7.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m63.1,54c0-.2,0-.4,0-.5,2.7,0,5.4-.2,8-.1.4,0,.2.5.4.7,0,.7,0,1.3,0,2,0,0,0,0,0,0,0,0-.1-.2-.2-.2.2-.9-.1-1.1-1.1-1.1-1.7,0-6,.4-7.1-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m71.5,54c-.2-.1-.2-.3-.2-.5-.3-.3-.3-.6-.4-1,0-.4,0-.7,0-1.1,0-.2.1-.4.3-.6,0,0,.2,0,.3,0,0,1.1,0,2.1,0,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m63.1,50.3c0-.4,0-.9,0-1.3,0,0,0,0,0,0,.2-.4.6-.4,1-.5,2.3-.3,4.6,0,6.8-.5.1,0,.2,0,.4.1v1.9c-.3.5-.7.6-1.2.7-2,0-3.9,0-5.9,0-.4,0-.8-.1-1.1-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m63.1,50.3c2.2,0,4.5,0,6.7,0,.5,0,1.1,0,1.5-.3,0,.3,0,.5,0,.8,0,.2,0,.4,0,.5-.3.5-.6.8-1.2.8-1.9-.2-3.8,0-5.7-.1-.4,0-.9,0-1.2-.4,0,0,0,0,0,0,0-.4,0-.9,0-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m71.3,48.2c-1.2.6-2.4.5-3.7.5-1.5,0-3,.2-4.5.2,0-.4,0-.9,0-1.3,1-.2,2-.7,3.1-.6,1.7,0,3.5.1,5.1-.7v1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m71.3,46.3c-.7.8-1.5,1.1-2.5,1.1-1.9-.1-3.8,0-5.6.2,0-.4,0-.9,0-1.3.2-.5.7-.5,1.1-.5,2.2.4,4.5-.3,6.7,0,.1,0,.3,0,.4.2,0,0,0,0,0,0,0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m63.1,45c0-.7,0-1.4,0-2.1.5.3,1.1.5,1.7,0,.4-.3.7,0,1.1,0,1.8.1,3.6.2,5.4.3,0,.4,0,.9,0,1.3-1.1.7-2.3.3-3.5.5-.9,0-1.8,0-2.7.3-.7.2-1.4.2-2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m63.1,45c.6-.4,1.2.2,1.9,0,2-.8,4.2-.4,6.3-.5,0,.5,0,1.1,0,1.6-2.1,0-4.1.4-6.2.2-.7,0-1.3-.2-2,0,0,0,0-.2,0-.3,0-.4,0-.7,0-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m71.8,59.6c0,.4,0,.9,0,1.3-.3.3-.7.4-1.1.4-2.3,0-4.6,0-7,0-.4,0-.7,0-1-.4,0-.9.5-1.1,1.3-1.1,2.6,0,5.1,0,7.7-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m63.1,51.6c2.4.1,4.8-.3,7.2.2.5,0,.7-.3,1-.5,0,.4,0,.7,0,1.1-.6.7-1.4.9-2.2.9-1.5,0-3.1,0-4.6,0-.7,0-1.2-.3-1.3-1,0-.3,0-.5,0-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m63.1,52.4c.3.4.6.7,1.3.6,2.3-.3,4.7.4,6.9-.6,0,.4,0,.7,0,1.1-1.8.5-3.7.2-5.5.3-.9,0-1.9.7-2.7-.3,0-.4,0-.7,0-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m1.9,24.6l-1.6,5.6c.2.3.5.6.8.7.3,0,.4-.1.7-.2.7-.1.9.4,1.5.4.8,0,.9-.8,1.7-.8.5,0,.7.4,1.3.6.5.2,1.3.2,2.5-.4,1.8-9.7,10.5-20.5,25.2-21.9,0,0,28.9-2.1,28.5,30.9h8.7c0-.1,2.6-25.9-21.5-36.4,0,0-20.1-10.5-39.6,7.8,0,0-6.9,7.5-8.4,13.8Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLockTop);
export default __webpack_public_path__ + "static/media/grey-lock-top.deb14c9daf6ac2425aeeec6050a0b52f.svg";
export { ForwardRef as ReactComponent };